module.exports = __webpack_public_path__ + "img/enterpriseTrainingImg3.25d987a6.png";